/**
 * Defines the typography for normal text
 */
import styled from 'styled-components'

import { TypographyBase } from './TypographyBase'

export const Text = styled(TypographyBase)``
